import * as moment from 'moment';

export class SuperListModel {
  public id: number;
  public title?: string;
  public description?: string;
  public date?: string | Date;
  public statusColorClass?: string;
  public order: number;
  public active: boolean;
  public expTitle: string;
  public expGroup: string;
  public category: string;
  public info_sup: string;
  public status: string;
  public icon: string;
  setTitle(refExpediteur: string) {
    return (this.title = refExpediteur);
  }

  setDescription(objet: string) {
    return (this.description = objet);
  }

  setDate(dateEntree: string) {
    return (this.date = moment(dateEntree).format('DD/MM/YYYY'));
  }

  setStatusColorClass() {
    return (this.statusColorClass = 'no_border');
  }

  setOrder(classementId?: number) {
    return (this.order = classementId);
  }

  setInfoSup(serviceProprietaireDescription?: string) {
    return (this.info_sup = serviceProprietaireDescription);
  }

  setStatus(status: string) {
    return (this.status = status);
  }

  setExpTitle(expediteur?: string) {
    return (this.expTitle = expediteur);
  }

  setExpGroup(serviceProprietaireDescription?: string) {
    return (this.expGroup = serviceProprietaireDescription);
  }

  setCategory(natureDescription?: string) {
    return (this.category = natureDescription);
  }

  setActive(isActive: boolean) {
    return (this.active = isActive);
  }

  setIcon(type: string) {
    if (type === 'E') {
      return (this.icon = '<i class="icons-courrier_type_entrant_from_global_SCSS icon"></i>');
    }
    if (type === 'I') {
      return (this.icon = '<i class="icons-courrier_type_interne_from_global_SCSS icon"></i>');
    }
    if (type === 'S') {
      return (this.icon = '<i class="icons-courrier_type_sortant_from_global_SCSS icon"></i>');
    }
  }
}
